import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useApiV2ModelContext } from '../../../contexts/ApiV2ModelContext';
import { LoadingMetrics } from './LoadingMetrics';
import { EmptyRange } from './EmptyRange';
import { VelocityReportContent } from './VelocityReportContent';
function getUniquePrs(sprint) {
    return [...new Set([...sprint.merged, ...sprint.review, ...sprint.workInProgress])];
}
export const PullRequestListQuery = ({ activeRepositoriesIds, pullRequestMetrics, repositories, repos, user, from, to, handleRegisterRepo }) => {
    const apiV2ModelContext = useApiV2ModelContext();
    const [loading, setLoading] = useState(true);
    const [pullRequests, setPullRequests] = useState(null);
    const fetchPullRequestList = async () => {
        const currentSprint = pullRequestMetrics[1].sprint;
        const currentUniquePRs = getUniquePrs(currentSprint);
        const reposSlugsWithHooks = Object.keys(repos).filter((slug) => repos[slug].active);
        const repositoriesIds = reposSlugsWithHooks.map((slug) => repos[slug].id);
        const results = await apiV2ModelContext.getPullRequestList(activeRepositoriesIds || repositoriesIds, currentUniquePRs ?? []);
        setPullRequests(results);
        setLoading(false);
    };
    useEffect(() => {
        fetchPullRequestList();
    }, [activeRepositoriesIds, pullRequestMetrics, repos]);
    if (loading || !pullRequests || !Array.isArray(pullRequests.pullRequests)) {
        return _jsx(LoadingMetrics, {});
    }
    if (pullRequests.pullRequests) {
        const previousSprint = pullRequestMetrics[0].sprint;
        const currentSprint = pullRequestMetrics[1].sprint;
        const currentUniquePRs = getUniquePrs(currentSprint);
        const currentNumberOfPRs = currentUniquePRs.length;
        const previousUniquePRs = getUniquePrs(previousSprint);
        const previousNumberOfPRs = previousUniquePRs.length;
        const currentCycleTime = currentSprint.getCycleTime();
        const previousCycleTime = previousSprint.getCycleTime();
        const dateTimes = pullRequestMetrics[1].daily.map((velocity) => velocity.startDate);
        const datasets = [
            pullRequestMetrics[1].daily.map((velocity) => velocity.workInProgressAvgTime),
            pullRequestMetrics[1].daily.map((velocity) => velocity.reviewAvgTime),
            pullRequestMetrics[1].daily.map((velocity) => velocity.mergedAvgTime),
        ];
        return _jsx(VelocityReportContent, { currentNumberOfPRs: currentNumberOfPRs, previousNumberOfPRs: previousNumberOfPRs, currentSprint: currentSprint, currentCycleTime: currentCycleTime, previousCycleTime: previousCycleTime, dateTimes: dateTimes, datasets: datasets, prList: pullRequests.pullRequests, repositories: repositories, user: user, activeRepositoriesIds: activeRepositoriesIds, from: from, to: to, handleRegisterRepo: handleRegisterRepo });
    }
    return _jsx(EmptyRange, {});
};
